<template>
    <label class="radioButton">{{ label }}
        <input type="radio" :name="name" :checked="isChecked" @change="inputChanged($event)">
        <span class="checkmark"></span>
    </label>
</template>
<script>
    export default {
        name: 'RadioButton',
        props:{
            isChecked: {type: Boolean, default: false},
            id:{type: String},
            name:{type: String},
            label:{type: String},
            value:{type: [Boolean, String]},
        },
        methods:{
            inputChanged(e){
                this.$emit('change-credit', e.target.checked)
            }
        }
    }
</script>
<style lang="scss">
    @import './RadioButton.scss';
</style>